import { render, staticRenderFns } from "./CragRoutePhotos.vue?vue&type=template&id=3a15474f"
import script from "./CragRoutePhotos.vue?vue&type=script&lang=js"
export * from "./CragRoutePhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports